<template>
    <q-page class="q-pa-md">
        <q-table :title="title"
                 :loading="loading"
                 :columns="columns"
                 :visible-columns="columnsVisible"
                 :data="dataSource"
                 :filter="filter"
                 row-key="Id"
                 :pagination.sync="pagination"
                 :rows-per-page-options="[ 5, 10, 15, 25, 50, 100 ]"
                 @request="onRequest">
            <template v-slot:top>
                <q-toolbar>
                    <q-input outlined v-model="filter"
                             dense clearable clear-icon="close"
                             placeholder="Search" debounce="300"
                             style="width:250px" class="q-mr-xs">
                        <template v-slot:prepend>
                            <q-icon name="search"></q-icon>
                        </template>
                    </q-input>
                    <q-btn round dense flat color="primary" icon="refresh" @click="refreshScreen">
                        <q-tooltip>
                            REFRESH
                        </q-tooltip>
                    </q-btn>

                    <q-space></q-space>

                    <div class="q-gutter-xs">
                        <q-btn label="Create"
                               color="primary"
                               @click="onCreateActionClick()">

                        </q-btn>

                    </div>
                </q-toolbar>
            </template>

            <template v-slot:body-cell-Actions="props">
                <q-td :props="props" auto-width>
                    <div class="q-gutter-xs">
                        <q-btn label="Edit"
                               color="primary"
                               @click="onEditActionClick(props.key, props.rowIndex, props.row)">
                        </q-btn>
                        <q-btn label="Delete"
                               color="primary"
                               @click="onDeleteActionClick(props.key, props.rowIndex, props.row)">

                        </q-btn>
                    </div>
                </q-td>
            </template>
        </q-table>
    </q-page>
</template>

<script>
    export { default } from './three-pl-lot-numbers-list-screen.js'
</script>